export enum AppointmentType
{
    Accident, 
    Breakdown,
    Inspection,
    External
}


